export const ACTION_CODE = 'TRAINING_PRODUCT_ORIGIN' + '_ACTION';
